import { Support } from '@/app/entities/Support'
import { httpClient } from '../http/httpClient'

export interface GetAllSupportsResponse {
  supports: Support[]
  pagination: {
    limit: number
    order: string
    skip: number
    sort: string
    total: number
  }
}

export interface GetAllSupportsParams {
  search?: string
  categories?: string[]
  limit?: number
  skip?: number
}

export async function getAllSupports(
  params?: GetAllSupportsParams | undefined,
) {
  const { data } = await httpClient.get<GetAllSupportsResponse>('/support', {
    params,
  })

  return data
}
